/**
 * Progress API: current_time must be within ~20s of the catalog duration for the section
 * being reported. The HTML5 duration often differs; prefer catalog when the player value
 * is outside that window.
 */
export function completionTimeWhenChapterEnds(
  catalogDurationSeconds: number | undefined | null,
  videoDurationFloor: number | null | undefined,
  lastReportedSeconds: number
): number {
  const video =
    videoDurationFloor != null &&
    Number.isFinite(videoDurationFloor) &&
    videoDurationFloor > 0
      ? Math.floor(videoDurationFloor)
      : null;

  if (
    catalogDurationSeconds != null &&
    Number.isFinite(Number(catalogDurationSeconds)) &&
    Number(catalogDurationSeconds) > 0
  ) {
    const sd = Math.floor(Number(catalogDurationSeconds));
    if (video != null) {
      const low = sd - 19;
      const high = sd + 19;
      if (video >= low && video <= high) {
        return video;
      }
    }
    return sd;
  }

  return video ?? Math.max(0, Math.floor(lastReportedSeconds));
}
